import { Typography } from '@mui/material';
import { useTheme } from '@mui/system';
import { useContext } from 'react';
import { CreateInvoicesValues, InvoicesContext } from '../contexts/InvoicesContext';
import PageTitle from '../../../../components/shared/PageTitle';

export const InvoiceTitle = () => {
  const { t, totalRows } = useContext(InvoicesContext) as CreateInvoicesValues;
  const theme = useTheme();

  return (
    <Typography
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        alignSelf: 'stretch',
      }}
    >
      <PageTitle>{t('title')}</PageTitle>
      <Typography
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: '2px 8px',
          borderRadius: '16px',
          border: '1px solid',
          borderColor: theme.palette.primary[200],
          background: theme.palette.primary[50],
          fontSize: '0.875rem',
          fontWeight: 500,
        }}
      >
        {`${totalRows} ${t('items')}`}
      </Typography>
    </Typography>
  );
};
